<template>
    <section>
        <v-app-bar app dense dark :style="{background: $vuetify.theme.themes['dark'].custom_bg_menu}">
            <v-app-bar-nav-icon @click="drawer"></v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <div class="pull-right">
                <!-- <v-btn icon @click="logout"><v-icon>mdi-logout</v-icon></v-btn> -->
                <span v-if="$route.name == 'bet_add'"><v-btn small class="float-right" color="error" @click="$router.push({name: 'bet_history'});">Go back</v-btn></span>
            </div>
        </v-app-bar>
    </section>
</template>

<script>
    export default {
        data(){
            return{

            };
        },
        computed: {

        },
        methods:{
            logout(){
                this.$Fire.$emit('logout');
            },
            drawer(){
                this.$Fire.$emit('sideDrawer');
            }
        },
        created(){

        },
        mounted() {
            // console.log(this.$route.name);
        }
    }
</script>
